import { HttpClient, HttpEventType } from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

export class HvbEncryptedUpload {
  private readonly file: File;
  private readonly http: HttpClient;
  private readonly baseUrl: string;
  public uploadUrl: string;
  private readonly options;
  private readonly stopUpload: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(file: File, options: any) {
    this.options = options;
    this.file = file;
    this.http = options.http;
    this.baseUrl = options.baseUrl;
  }

  public stop() {
    this.stopUpload.next(true);
  }

  public async start(): Promise<void> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', this.file);

      this.http.post(this.baseUrl + '/upload', formData, {
        reportProgress: true,
        observe: 'events',
      }).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            const uploadProgress = Math.round((100 * event.loaded) / event.total);
            this.emitProgress(uploadProgress);
          } else if (event.type === HttpEventType.Response && event.status === 200) {
            this.emitSuccess(event.body.fileId, event.body.fileSecret);
            resolve();
          }
        },
        (error) => {
          this.stopUpload.next(true);
          this.options.onError();
          reject(new Error(error));
        }
      );
    });
  }

  private emitProgress(uploadProgress): void {
    if (typeof this.options.onProcessUpdate === 'function') {
      this.options.onProcessUpdate(uploadProgress);
    }
  }

  private emitSuccess(fileId: string, fileSecret: string): void {
    if (typeof this.options.onSuccess === 'function') {
      this.options.onSuccess(fileId, fileSecret);
    }
  }
}
